import { createControlField } from '@lib/common';
import { blue } from '@material-ui/core/colors';
import styled from 'styled-components';
import { FormControl, InputLabel, Select, FormHelperText } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

const StatusAutoComplete = ({ value, onChange }) => {
  const form = useFormContext();

  return (
    <Styles>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="funding_status_label">Content Funding Status</InputLabel>
        <Select
          labelId="funding_status_label"
          id="funding_status"
          name="funding_status"
          inputRef={form.register}
          native
          label="Content Funding Status"
          defaultValue="Content Funding Status">
          <option value=""></option>
          <option value="open for funding">Open for funding</option>
          <option value="open for co-production">Open for co-production</option>
        </Select>
        <FormHelperText>Funding Status of this Content</FormHelperText>
      </FormControl>
    </Styles>
  );
};

const Styles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const ContentFundingStatusField = createControlField(StatusAutoComplete, []);
